// extracted by mini-css-extract-plugin
export default {"buttonArea":"ButtunArea_buttonArea__yKi4n"};